import React from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

class LockedPurchaseNotification extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <Paper
          elevation={1}
          style={{ padding: `16px 20px 16px 20px`, backgroundColor: `#fff3cd` }}
        >
          <Typography variant="subtitle1" style={{ color: `#856404` }}>
            WARNING: This booking has been added to Xero, changes can mess the accounts team up.
            If you must make changes, please email accounts@bonzabiketours.com to explain the changes
            made to avoid confusion.
          </Typography>
        </Paper>
      </div>
    );
  }
}

export default LockedPurchaseNotification;



/** WEBPACK FOOTER **
 ** ./src/components/LockedPurchaseNotification.js
 **/